import { Badge, Card, Divider, Group, Stack, Text, Title } from '@mantine/core';
import type { UserOverview } from '../../hooks/useUserDetail';

function Row({ label, value }: { label: string; value: string }) {
  return (
    <Group justify="space-between" gap="xs">
      <Text size="sm" c="dimmed">
        {label}
      </Text>
      <Text size="sm">{value}</Text>
    </Group>
  );
}

/** The metrics layer — and the entire screen for anyone who never opens content. */
export function LeftRail({ overview }: { overview: UserOverview }) {
  const p = overview.profile;
  return (
    <Card withBorder padding="md">
      <Stack gap="xs">
        <Title order={5}>{p.display_name ?? p.email}</Title>
        <Text size="xs" c="dimmed">
          {p.email}
        </Text>
        <Group gap={4}>
          {p.is_sim && (
            <Badge size="xs" color="grape" variant="light">
              sim
            </Badge>
          )}
          {p.is_admin && (
            <Badge size="xs" color="blue" variant="light">
              admin
            </Badge>
          )}
          {p.deleted_at && (
            <Badge size="xs" color="red" variant="light">
              deleted
            </Badge>
          )}
        </Group>

        <Divider my="xs" />
        <Row label="Plan" value={p.subscription_tier} />
        <Row label="Status" value={p.subscription_status} />
        <Row label="Joined" value={new Date(p.created_at).toLocaleDateString()} />
        <Row label="Timezone" value={p.user_timezone} />
        <Row
          label="Streak"
          value={
            overview.streak
              ? `${overview.streak.current_streak} (best ${overview.streak.longest_streak})`
              : '—'
          }
        />
        <Row label="Onboarding" value={p.has_completed_onboarding ? 'complete' : 'incomplete'} />
        <Row
          label="Synthesis"
          value={overview.latest_synthesis ? overview.latest_synthesis.status : 'never run'}
        />

        <Divider my="xs" />
        <Text size="sm" c="dimmed">
          Compass words
        </Text>
        <Group gap={4}>
          {p.compass_words.length > 0 ? (
            p.compass_words.map((w) => (
              <Badge key={w} size="sm" variant="outline">
                {w}
              </Badge>
            ))
          ) : (
            <Text size="sm">—</Text>
          )}
        </Group>

        <Divider my="xs" />
        <Text size="sm" c="dimmed">
          Activity
        </Text>
        {Object.entries(overview.counts).map(([key, value]) => (
          <Row key={key} label={key.replace(/_/g, ' ')} value={String(value)} />
        ))}
      </Stack>
    </Card>
  );
}
